import {
  createRouter,
  createWebHistory,
  type NavigationGuardNext,
  type RouteLocationNormalizedGeneric,
  type RouteLocationNormalizedLoadedGeneric,
} from 'vue-router'

import { ROUTES } from '@/shared'

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: 'is-active-router-link',
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  },
  routes: [
    {
      path: ROUTES.PAYMENT.PATH,
      name: ROUTES.PAYMENT.NAME,
      component: () => import('@/pages/PaymentPage.vue'),
    },
    {
      path: ROUTES.STATUS.PATH,
      name: ROUTES.STATUS.NAME,
      component: () => import('@/pages/StatusPage.vue'),
      beforeEnter: requirePaymentQuery,
    },
    {
      path: ROUTES.NOT_FOUND.PATH,
      name: ROUTES.NOT_FOUND.NAME,
      component: () => import('@/pages/NotFoundPage.vue'),
    },
  ],
})

function requirePaymentQuery(
  to: RouteLocationNormalizedGeneric,
  _: RouteLocationNormalizedLoadedGeneric,
  next: NavigationGuardNext
) {
  if (!to.query.paymentId) {
    next({ name: ROUTES.NOT_FOUND.NAME })
  } else {
    next()
  }
}

export default router
